module.exports = __webpack_public_path__ + "media/waves2.585e9201.webm";